import React from "react";
import PropTypes from "prop-types";
import Tooltip from "react-bootstrap/Tooltip";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Time from "../../../../components/Time";
import DropdownFilter from "../../../../components/DropdownFilter";

const HistoryDropdownLabel = historyItem => (
  <>
    <Time time={historyItem.analysis_time} /> - {historyItem.platform}
  </>
);

const historyDropdownItems = historyItems => {
  const dropdownMenu = historyItems.map(e => ({
    label: <HistoryDropdownLabel {...e} />,
    value: e.analysis_id
  }));
  dropdownMenu.unshift({ label: "All Analyses", value: null });
  return dropdownMenu;
};

const RLCloudSandboxToolbar = ({
  historyAnalysis,
  historyAnalysisMapper = historyDropdownItems,
  activeFilter,
  handleHistoryDropdownChange,
  isStoredReport,
  title = <span>All Analyses</span>,
  style
}) => {
  const menuItems =
    historyAnalysis &&
    historyAnalysisMapper(isStoredReport ? [] : historyAnalysis);

  const dropdownFilterProps = {
    eventKey: activeFilter,
    title,
    field: "type",
    menuItems,
    onFilterChange: ({ value }) => handleHistoryDropdownChange(value),
    active: activeFilter,
    activeFilter,
    styles: {
      menu: { maxHeight: "330px", overflowY: "auto" }
    }
  };

  return (
    <div className="toolbar" style={style}>
      {isStoredReport ? (
        <OverlayTrigger
          key="rl-cloud-sandbox-toolbar-menu"
          overlay={
            <Tooltip
              id="rl-cloud-sandbox-toolbar-menu-tooltip"
              className="rl-cloud-sandbox-toolbar-menu-tooltip"
            >
              Reports for particular analysis not available locally.
            </Tooltip>
          }
          placement="top"
        >
          <div>
            <DropdownFilter {...dropdownFilterProps} disabled />
          </div>
        </OverlayTrigger>
      ) : (
        <DropdownFilter {...dropdownFilterProps} />
      )}
    </div>
  );
};

RLCloudSandboxToolbar.propTypes = {
  historyAnalysis: PropTypes.arrayOf(PropTypes.object),
  historyAnalysisMapper: PropTypes.func,
  activeFilter: PropTypes.string,
  title: PropTypes.element,
  handleHistoryDropdownChange: PropTypes.func,
  isStoredReport: PropTypes.bool,
  style: PropTypes.shape()
};

export default RLCloudSandboxToolbar;
